/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'project': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M35.967 24.807l-3.723-11.371c-.088-.27-.387-.436-.665-.436H16.421c-.278 0-.577.221-.665.49l-3.723 11.316C12.019 24.849 12 35.5 12 35.5c0 .275.225.5.5.5h23c.275 0 .5-.225.5-.5 0 0-.02-10.651-.033-10.693zM17.938 16h12.125l3.032 9H29l-2 5h-6l-2-5h-4.095l3.033-9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/project.js